import React, { useEffect, useState } from 'react'

const InfiniteScroll = ({ tag = "li", callback }) => {

    const [target, setTarget] = useState()

    useEffect(() => {
        let observer
        if (!target) return
        observer = new IntersectionObserver(([ entry ]) => {
            if (entry.isIntersecting) {
                callback && callback()
            }
        })
        observer.observe(target)
        return () => {
            observer && observer.disconnect()
        }
    }, [callback, target])

    const CustomTag = tag
        return (
        <CustomTag className="infiniteTarget" ref={setTarget} />
    )
}


export default InfiniteScroll